import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { request } from "@/api/client";

export const FreeTierLimitsSchema = z.object({
  natal: z.number().int().nonnegative(),
  transit_trial_days: z.number().int().nonnegative(),
  transits_daily_free: z.number().int().nonnegative(),
});
export type FreeTierLimits = z.infer<typeof FreeTierLimitsSchema>;
export type FreeTierKey = keyof FreeTierLimits;

const KEY = ["admin", "free-tier"];

export function useFreeTier() {
  return useQuery({
    queryKey: KEY,
    queryFn: ({ signal }) =>
      request({
        path: "/api/admin/free-tier-limits",
        schema: FreeTierLimitsSchema,
        signal,
      }),
  });
}

export function usePatchFreeTierLimit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: { feature_key: FreeTierKey; value: number }) =>
      request({
        method: "PATCH",
        path: `/api/admin/free-tier-limits/${args.feature_key}`,
        body: { value: args.value },
        schema: FreeTierLimitsSchema,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
